function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { cn } from "../../common/helpers.js";
import { Button } from "../Button/index.js";
import { Typography } from "../Typography/index.js";
/**
 * Award - [API](https://scl.sharp.com/?path=/docs/components-award) | [DSM](https://sharphealthcare.notion.site/In-dev-Award-fca9ddc8f86c4f2d97cdc11af0a3edd4)
 *
 * @example
 *
 * <Award image={{ src: "..." }} heading="..." description="..." />
 */ const Award = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { image = {}, heading, button, description, slots = {}, slotProps = {}, className: rootClassName, as } = props, rest = _object_without_properties(props, [
        "image",
        "heading",
        "button",
        "description",
        "slots",
        "slotProps",
        "className",
        "as"
    ]);
    const Root = as !== null && as !== void 0 ? as : 'div';
    var _slots_image;
    // Image
    const Image = (_slots_image = slots.image) !== null && _slots_image !== void 0 ? _slots_image : 'img';
    const { className: imagePropClassName } = image, imagePropProps = _object_without_properties(image, [
        "className"
    ]);
    var _slotProps_image;
    const _ref = (_slotProps_image = slotProps.image) !== null && _slotProps_image !== void 0 ? _slotProps_image : {}, { className: imageSlotPropsClassName } = _ref, imageSlotProps = _object_without_properties(_ref, [
        "className"
    ]);
    const imageProps = slots.image ? imageSlotProps : _object_spread({}, imagePropProps, imageSlotProps);
    var _slots_heading;
    // heading
    const Heading = (_slots_heading = slots.heading) !== null && _slots_heading !== void 0 ? _slots_heading : Typography;
    const defaultHeadingProps = {
        variant: 'h4',
        as: 'p',
        children: heading
    };
    var _slotProps_heading;
    const _ref1 = (_slotProps_heading = slotProps.heading) !== null && _slotProps_heading !== void 0 ? _slotProps_heading : {}, { className: headingClassNameSlotProps } = _ref1, restHeadingSlotProps = _object_without_properties(_ref1, [
        "className"
    ]);
    const headingProps = (slots === null || slots === void 0 ? void 0 : slots.heading) ? slotProps.heading : _object_spread({}, defaultHeadingProps, restHeadingSlotProps);
    var _slots_description;
    // description
    const Description = (_slots_description = slots.description) !== null && _slots_description !== void 0 ? _slots_description : Typography;
    const defaultDescriptiongProps = {
        as: 'div',
        variant: 'body',
        children: description
    };
    var _slotProps_description;
    const _ref2 = (_slotProps_description = slotProps.description) !== null && _slotProps_description !== void 0 ? _slotProps_description : {}, { className: descriptionClassNameSlotProps } = _ref2, restDescriptionSlotProps = _object_without_properties(_ref2, [
        "className"
    ]);
    const descriptionProps = slots.description ? restDescriptionSlotProps : _object_spread({}, defaultDescriptiongProps, restDescriptionSlotProps);
    var _slots_button;
    // button
    const ButtonComponent = (_slots_button = slots.button) !== null && _slots_button !== void 0 ? _slots_button : Button;
    const buttonProps = slots.button ? slotProps.button : _object_spread({}, button, slotProps === null || slotProps === void 0 ? void 0 : slotProps.button);
    return /*#__PURE__*/ _jsxs(Root, _object_spread_props(_object_spread({
        ref: ref,
        className: cn('flex flex-col md:flex-row gap-x-8', rootClassName)
    }, rest), {
        children: [
            /*#__PURE__*/ _jsx(Image, _object_spread({
                className: cn('mb-6 md:mb-0 m-h-[150px] m-w-[150px] h-[150px] w-[150px] object-contain', imageSlotPropsClassName)
            }, imageProps)),
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(Heading, _object_spread({
                        className: cn('mb-3', headingClassNameSlotProps)
                    }, headingProps)),
                    /*#__PURE__*/ _jsx(Description, _object_spread({
                        className: cn('mb-6 scl-rich-text', descriptionClassNameSlotProps)
                    }, descriptionProps)),
                    button && /*#__PURE__*/ _jsx(ButtonComponent, _object_spread({
                        variant: "outlined",
                        width: "md",
                        size: "sm"
                    }, buttonProps))
                ]
            })
        ]
    }));
});
export { Award };
